export const config = {
    randomOrgKey: "cae9e71b-d7f3-450f-8cdd-c25f8c501de6",
    enableRandomOrg: true,
    randomOrgBasicApi: "https://api.random.org/json-rpc/4/invoke",
}